import { render } from "./IncomeTicketsDetail.vue?vue&type=template&id=2efdbbea&ts=true"
import script from "./IncomeTicketsDetail.vue?vue&type=script&lang=ts"
export * from "./IncomeTicketsDetail.vue?vue&type=script&lang=ts"

import "./IncomeTicketsDetail.vue?vue&type=style&index=0&id=2efdbbea&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__